import { Dropdown, DropdownButton } from "@similarweb/ui-components";
import DropdownItem from "./DropdownItem/DropdownItem";
import { translate } from "app/filters/i18nFilter";
import { DropdownContainer } from "./styles";
import type { ReactElement } from "react";
import { useMemo } from "react";
import type { Domain, SelectedWebsitesItem } from "../../types";
import { websitesDropdownPopupHeight } from "../../constants";
import ChipList from "../../../segments/components/Chip/ChipList";
import { DropdownSelector } from "../../styles";

type WebsitesDropdownProps = {
    selectedItems: SelectedWebsitesItem;
    items: Domain[];
    setSelectedItem: (domain: Domain) => void;
    selectedIdsCount: number;
    searchFilter: (searchText: string, item: ReactElement) => boolean;
    placeholder: string;
    searchPlaceHolder: string;
    maxItemsSelectedLimit: number;
};

const WebsitesDropdown = ({
    selectedItems,
    items,
    setSelectedItem,
    selectedIdsCount,
    searchFilter,
    placeholder,
    searchPlaceHolder,
    maxItemsSelectedLimit,
}: WebsitesDropdownProps) => {
    const chipsSelectedItems = useMemo(() => items.filter((item) => item.visible), [items]);

    return (
        <DropdownContainer>
            {items.length ? (
                <ChipList
                    selectedItems={chipsSelectedItems}
                    onRemove={setSelectedItem}
                />
            ) : null}
            <Dropdown
                selectedIds={selectedItems}
                hasSearch
                searchFilter={searchFilter}
                disabled={!items.length}
                dropdownPopupHeight={websitesDropdownPopupHeight}
                searchPlaceHolder={translate(searchPlaceHolder)}
            >
                {[
                    <DropdownSelector
                        isDisabled={!items.length}
                        key="uniquekey"
                    >
                        <DropdownButton key="uniquekey">{translate(placeholder)}</DropdownButton>
                    </DropdownSelector>,
                    ...items?.map((item) => (
                        <DropdownItem
                            key={item.id}
                            item={item}
                            customOnClick={setSelectedItem}
                            isSelected={selectedItems[item.id]}
                            isDisabled={selectedIdsCount >= maxItemsSelectedLimit ? !selectedItems[item.id] : null}
                        />
                    )),
                ]}
            </Dropdown>
        </DropdownContainer>
    );
};
export default WebsitesDropdown;
